import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import type { Store } from '@sp/shared'
import { Sheet } from './Sheet.tsx'
import { StoreForm } from './StoreForm.tsx'
import { TripStart } from './TripStart.tsx'

/** Novy nakup (navrh v3): jedina otazka „Kam jdeš?", druh nakupu se nevybira. */
export function NewTripSheet({
  open,
  onClose,
  groupId,
  stores,
  onStoreAdded,
}: {
  open: boolean
  onClose(): void
  groupId: string
  stores: readonly Store[]
  onStoreAdded(store: Store): void
}) {
  const navigate = useNavigate()
  const [addingStore, setAddingStore] = useState(false)
  const [addedStoreId, setAddedStoreId] = useState<string | null>(null)

  useEffect(() => {
    if (open) setAddingStore(false)
  }, [open])

  // Formular obchodu jen prekryje vyber — rozpracovany nakup (obchody, datum, nazev) zustane.
  return (
    <Sheet open={open} onClose={onClose} title={addingStore ? 'Přidat obchod' : 'Nový nákup'}>
      {open && addingStore && (
        <StoreForm
          groupId={groupId}
          stores={stores}
          onCancel={() => setAddingStore(false)}
          onSaved={(store) => {
            onStoreAdded(store)
            setAddedStoreId(store.id)
            setAddingStore(false)
          }}
        />
      )}
      {open && (
        <div hidden={addingStore}>
          <TripStart
            groupId={groupId}
            stores={stores}
            addedStoreId={addedStoreId}
            onAddStore={() => setAddingStore(true)}
            onCreated={(trip) => {
              onClose()
              navigate(`/nakup/${trip.id}`)
            }}
          />
        </div>
      )}
    </Sheet>
  )
}
